import { AssessmentPeriodDTO, AssessmentPeriodRequestDTO, ProjectDTO } from '@/models';
import { axiosBase } from './axios-base';

export const fetchAssessmentPeriods = (): Promise<{ data: AssessmentPeriodDTO[] }> => {
    return axiosBase.get('/api/assessmentPeriods');
};

export const fetchAssessmentPeriodById = (id: string): Promise<{ data: AssessmentPeriodDTO }> => {
    return axiosBase.get(`/api/assessmentPeriod/${id}`);
};

export const createNewAssessmentPeriod = (body: AssessmentPeriodRequestDTO): Promise<{ data: AssessmentPeriodDTO }> => {
    return axiosBase.put('/api/assessmentPeriod', body)
}

export const updateAssessmentPeriod = (body: AssessmentPeriodRequestDTO): Promise<{ data: AssessmentPeriodDTO }> => {
    return axiosBase.put('/api/assessmentPeriod', body)
}

export const closeAssessmentPeriod = (id: string): Promise<void> => {
    return axiosBase.put(`/api/assessmentPeriod/${id}/close`);
}

export const fetchProjectsInPeriod = (id: string): Promise<{ data: ProjectDTO[] }> => {
    return axiosBase.get(`/api/assessmentPeriod/${id}/projects`)
}
